import React from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "../CustomButton";
import CircularProgressBar from "../CircularProgressBar";
import useApp from "../../hooks/useApp";
import "./styles.scss";

const LoanHeaderCard = ({
  percentage,
  totalPaid,
  balanceRemaining,
  availableToDisburse,
  onClick,
}) => {
  const { t } = useTranslation();
  const { isRTL } = useApp();

  const loanStatusData = [
    {
      label: t("finance-detail.total_paid"),
      value: totalPaid,
      ellipseColor: "var(--bs-neutral-900)",
    },
    {
      label: t("finance-detail.balance_remaining"),
      value: balanceRemaining,
      ellipseColor: "var(--bs-neutral-50)",
    },
    {
      label: t("finance-detail.available_to_disburse"),
      value: availableToDisburse,
      ellipseColor: "var(--bs-primary-200)",
    },
  ];

  return (
    <div className="loan-header-card">
      <CircularProgressBar
        percentage={percentage}
        label={t("finance-detail.complete")}
      />
      {loanStatusData.map((item, index) => (
        <div className="loan-card-status-container " key={index}>
          <div className="label-container">
            <span
              className="circle-ellipse"
              style={{ backgroundColor: item.ellipseColor }}
            />
            <span className={isRTL ? "label-text-rtl" : "label-text"}>
              {item.label}
            </span>
          </div>
          <span className="text-value">{item.value}</span>
        </div>
      ))}
      {/* <CustomButton
        text={t("finance-detail.request_disbursement")}
        style={{ marginTop: "24px", marginBottom: "24px" }}
        onClick={onClick}
      /> */}
    </div>
  );
};

export default LoanHeaderCard;
